import config from "../constants/config";

export const parseRpDetailsValue = (storedValue) => {
  const decodedString = decodeURIComponent(storedValue);
  const normalizedString = decodedString.startsWith("c{")
    ? decodedString.slice(1)
    : decodedString;

  return JSON.parse(normalizedString);
};

export const isAccountCreationHiddenForClient = (clientId) => {
  const accountCreationHiddenClientIds =
    config.environment?.accountCreationHidden?.clientIds || [];

  return accountCreationHiddenClientIds.includes(clientId);
};
